// Client-side capability and identity checks only. The API authenticates tokens.
export function readTokenClaims(token) {
    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(payload), c => c.charCodeAt(0))));
    } catch { return null; }
}

export function sameSessionToken(expected, current) {
    if (typeof expected !== 'string' || !expected || typeof current !== 'string' || !current) return false;
    if (expected === current) return true;
    const before = readTokenClaims(expected), after = readTokenClaims(current);
    return typeof before?.sid === 'string' && before.sid.length > 0 && before.sid === after?.sid &&
        before.user != null && before.user === after.user && before.dealer != null && before.dealer === after.dealer;
}
